<script setup>
import { RouterLink } from 'vue-router'
import { CIcon } from '@coreui/icons-vue'
import { cilApps } from '@coreui/icons'

import { AppSidebarNav } from '@/components/AppSidebarNav.js'
import { useSidebarStore } from '@/stores/sidebar.js'

const sidebar = useSidebarStore()
</script>

<template>
  <CSidebar
    class="border-end"
    colorScheme="dark"
    position="fixed"
    :unfoldable="sidebar.unfoldable"
    :visible="sidebar.visible"
    @visible-change="(value) => sidebar.toggleVisible(value)"
  >
    <CSidebarHeader class="border-bottom">
      <RouterLink custom to="/" v-slot="{ href, navigate }">
        <CSidebarBrand
          v-bind="$attrs"
          as="a"
          :href="href"
          class="qa-sidebar-brand"
          @click="navigate"
        >
          <span class="qa-sidebar-brand__mark">
            <CIcon :icon="cilApps" :height="24" />
          </span>
          <span class="qa-sidebar-brand__copy">
            <span class="qa-sidebar-brand__title">Query Agent</span>
            <span class="qa-sidebar-brand__subtitle">Super App</span>
          </span>
        </CSidebarBrand>
      </RouterLink>
      <CCloseButton class="d-lg-none" dark @click="sidebar.toggleVisible()" />
    </CSidebarHeader>
    <AppSidebarNav />
    <CSidebarFooter class="border-top d-none d-lg-flex">
      <CSidebarToggler @click="sidebar.toggleUnfoldable()" />
    </CSidebarFooter>
  </CSidebar>
</template>
